import { render, staticRenderFns } from "./CommentHeader.vue?vue&type=template&id=4a676bbf&"
import script from "./CommentHeader.vue?vue&type=script&lang=js&"
export * from "./CommentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports